import { Component, OnInit, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { InventoryCountsComponent } from '../../inventory-counts/inventory-counts.component';

@Component({
  selector: 'app-count-header',
  templateUrl: './count-header.component.html',
  styleUrls: ['./count-header.component.scss']
})
export class CountHeaderComponent implements OnInit {
  @Input() inventory;
  @Input() title: string = '';
  constructor(
    private _dialogRef: MatDialogRef<InventoryCountsComponent>
  ) { }

  ngOnInit(): void {
  }

  onClose(){
    this._dialogRef.close();
  }

}
